// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import './BlendPlaceholderCards.css';
// Analytics
import * as Analytics from '../../common/analytics';

const Tag = ({ icon, children, variant = '' }) => (
  <span className={`blend-tag ${variant}`}>
    <i className={`fa ${icon}`} /> {children}
  </span>
);

const CardText = ({ title, description, hint, tags = [] }) => (
  <div className="blend-card-text">
    <p className="blend-card-title">{title}</p>
    <p className="blend-card-desc">{description}</p>

    {hint && <span className="blend-card-hint">{hint}</span>}

    {!!tags.length && (
      <div className="blend-card-tags">
        {tags.map((t, i) => (
          <Tag key={i} icon={t.icon} variant={t.variant}>
            {t.label}
          </Tag>
        ))}
      </div>
    )}
  </div>
);

const BlendCard = ({ variant, icon, children, action }) => (
  <div className={`blend-card ${variant}`}>
    <div className="blend-card-content">
      {icon}
      {children}
    </div>
    {action}
  </div>
);

const BlendPlaceholderCards = () => (
  <div className="blends-stacked">
    <BlendCard
      variant="blend-card-primary"
      icon={
        <div className="blend-card-icon">
          <i className="fa fa-plus" />
        </div>
      }
      action={
        <Link
          className="blend-card-button"
          to="/blend/calculadora/new/"
          onClick={() => {
            Analytics.logTappedCreateBlend();
          }}
        >
          Novo blend
        </Link>
      }
    >
      <CardText
        title="Crie seu blend"
        description="Escolha as carnes, defina proporções e monte sua combinação ideal."
        hint="Leva menos de 1 minuto"
        tags={[
          { icon: 'fa-cutlery', label: 'Carnes selecionadas' },
          { icon: 'fa-balance-scale', label: 'Proporções precisas' },
        ]}
      />
    </BlendCard>

    <BlendCard
      variant="blend-card-secondary"
      icon={
        <div className="blend-card-icon secondary">
          <i className="fa fa-list" />
        </div>
      }
      action={
        <Link className="blend-card-button secondary" to="/blend/meus-blends/">
          Meus blends
        </Link>
      }
    >
      <CardText
        title="Veja seus blends"
        description="Acesse seus blends salvos e repita pedidos rapidamente."
        tags={[
          {
            icon: 'fa-clock-o',
            label: 'Histórico rápido',
            variant: 'empty-tag',
          },
          {
            icon: 'fa-refresh',
            label: 'Pedido em 1 clique',
            variant: 'empty-tag',
          },
        ]}
      />
    </BlendCard>
  </div>
);

export default BlendPlaceholderCards;
